import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import 'video.js/dist/video-js.css';

import { setUpgradeModal } from '../actions/App';

import UpgradeBoard from './UpgradeBoard';
import ErrorBoundary from './ErrorBoundary';

const UpgradeModal = ({
  location,
  history,
  handleUpgradeModal,
  upgradeModal,
  features,
}) => {
  const [open, setOpen] = useState(false);

  const lockedFeature = features.find(f => (f.slug === upgradeModal));

  useEffect(() => {
    if (upgradeModal) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [upgradeModal]);

  useEffect(() => {
    if (!upgradeModal && location.state?.upgradeModal) {
      handleUpgradeModal(location.state?.upgradeModal);

      const { upgradeModal: _, ...restState } = location.state;
      history.replace(location.pathname, restState);
    }
  }, [handleUpgradeModal, location.state, upgradeModal, location.pathname, history]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleModalOpened = useCallback(() => {
    if (!window.$('body').hasClass('modal-open')) {
      window.$('body').addClass('modal-open');
    }
  }, []);

  /** Cleanup player on modal close */
  const handleModalClosed = useCallback(() => {
    handleUpgradeModal(null);
  }, [handleUpgradeModal]);

  if (!upgradeModal) return null;

  if (!lockedFeature) {
    return null;
  }
  if ((!lockedFeature.plans || lockedFeature.plans.length === 0)) {
    return null;
  }

  return (
    <Modal
      isOpen={open}
      toggle={handleClose}
      modalClassName="modal-blur"
      className="modal-upgrade"
      onOpened={handleModalOpened}
      onClosed={handleModalClosed}
      autoFocus={false}
      zIndex={999999}
    >
      <ErrorBoundary>
        <ModalHeader
          toggle={handleClose}
          close={(
            <Button className="close" onClick={handleClose}>
              <span aria-hidden="true"><i className="fal fa-times" /></span>
            </Button>
          )}
        />
        <ModalBody>
          <UpgradeBoard
            feature={upgradeModal}
            buttonCallback={handleClose}
          />
        </ModalBody>
      </ErrorBoundary>
    </Modal>
  );
};

const mapStateToProps = state => ({
  trialEndsAt: state.Auth.profile?.client?.trial_ends_at,
  isInTrial: state.Auth.profile?.client?.is_in_trial,
  upgradeModal: state.App.upgradeModal,
  features: state.App.features,
});

const mapDispatchToProps = dispatch => ({
  handleUpgradeModal: (modal) => {
    dispatch(setUpgradeModal(modal));
  },
});

UpgradeModal.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  handleUpgradeModal: PropTypes.func.isRequired,
  upgradeModal: PropTypes.string,
  features: PropTypes.array,
  trialEndsAt: PropTypes.string,
  isInTrial: PropTypes.bool,
};

UpgradeModal.defaultProps = {
  features: [],
  upgradeModal: null,
  trialEndsAt: null,
  isInTrial: false,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UpgradeModal));
